/**
 * The key a definition caches under: the campaign id, then the definition's own key. An
 * invalidation, `setQueryData` or `cancelQueries` for a defined query builds its key here, or it
 * misses the cache entry.
 */
export function campaignKey(campaignId: string | null | undefined, key: readonly unknown[]): unknown[] {
  return [campaignId ?? null, ...key];
}

export const DEFINITION: unique symbol = Symbol('definition');

let definitions = 0;

/** What a read definition is addressed by: its number, which every query it runs carries as `meta.definition`, and its key. */
export interface Definition<P> {
  readonly id: number;
  readonly key: (params: P) => readonly unknown[];
}

/**
 * A read definition a write's `edit` or a `refresh` can address: the hook `defineQuery` returns,
 * carrying its definition. `D` is the cached data an edit changes.
 */
export interface Defined<P, D> {
  readonly [DEFINITION]: Definition<P> & { readonly data?: D };
}

export function newDefinition<P>(key: (params: P) => readonly unknown[]): Definition<P> {
  return { id: ++definitions, key };
}

/** The `meta` a definition's query carries, so an edit can find every entry of it. */
export function definitionMeta(definition: { readonly id: number }, reads?: Record<string, unknown>): Record<string, unknown> {
  return { ...reads, definition: definition.id };
}
